import { showDeleteQuestionState } from '@/atoms';
import useAuth from '@/hooks/useAuth';
import { useUserCouncil } from '@/hooks/useUserCouncil';
import { useDeleteQuestion } from '@/services/questions';
import { ModalLayout } from 'moh-ui'
import { useRecoilState } from 'recoil';
import { Button, Group } from '@mantine/core';
import { notifications } from '@mantine/notifications';

export default function DeleteQuestionModal() {
    const [show, setShow] = useRecoilState(showDeleteQuestionState);
    const { user } = useAuth();
  const council = useUserCouncil();
    const {
        mutate: deleteQuestion,
        isPending: isDeleting,
    } = useDeleteQuestion();

    const handleDelete = () => {
        if (!show?.question) return;

        deleteQuestion({
            questionId: show.question.id,
            councilId: council?.id
        }, {
            onSuccess: () => {
                notifications.show({
                    title: "Success",
                    message: "Question deleted successfully",
                    color: "green",
                });
                setShow(null);
            },
            onError: (error) => {
                notifications.show({
                    title: "Error",
                    message: error.response?.data?.message || "Failed to delete question",
                    color: "red",
                });
            },
        });
    };

    return (
        <ModalLayout
            open={Boolean(show?.show)}
            onClose={() => setShow(null)}
        >
            <div>Are you sure you want to delete this question?</div>
            <div className="my-2 font-semibold">{show?.question?.translations?.EN || 'No question text available'}</div>
            <Group justify="right" mt="md">

                <Button
                    variant="outline"
                    onClick={() => setShow(null)}
                    disabled={isDeleting}
                >
                    Cancel
                </Button>
                <Button
                    color="red"
                    loading={isDeleting}
                    onClick={handleDelete}
                >
                    Delete
                </Button>
            </Group>
        </ModalLayout>
    )
}
